import { PayloadAction } from '@reduxjs/toolkit'
import {
  LOG_OUT,
  UPDATE_AUTH_TOKEN,
  UPDATE_EMAIL_ADDRESS,
  UPDATE_REFRESH_TOKEN,
  UPDATE_UUID
} from '../../constants'
import { ClientUser } from '../../../../../common/interfaces/User'

export const initialState: ClientUser = {
  email: '',
  id: '',
  auth: {
    accessToken: '',
    refreshToken: ''
  }
}

export function userReducer(
  state: ClientUser = initialState,
  action: PayloadAction<any>
): ClientUser {
  switch (action.type) {
    case UPDATE_EMAIL_ADDRESS: {
      return {
        ...state,
        email: action.payload.email
      }
    }
    case UPDATE_UUID: {
      return {
        ...state,
        id: action.payload.id
      }
    }
    case UPDATE_AUTH_TOKEN: {
      return {
        ...state,
        auth: action.payload.auth
      }
    }
    case UPDATE_REFRESH_TOKEN: {
      return {
        ...state,
        auth: {
          ...state.auth,
          refreshToken: action.payload.token
        }
      }
    }
    case LOG_OUT: {
      return {
        ...state,
        auth: {
          accessToken: '',
          refreshToken: ''
        }
      }
    }
    default:
      return state
  }
}
